import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DefaultService } from '../../../utils/default.service';
import { ApiService } from '../../../shared/api.service';
import { TableSchema } from '../../../utils/table-schema';
import { CcassService } from '../../ccass.service';
import { SIDE_NAVE_TITLES } from '../../utils/util-constants';
import { MessageService } from 'primeng/api';
import { DataService } from '../../../data.service';

@Component({
  selector: 'app-salesperson-mapping',
  templateUrl: './salesperson-mapping.component.html',
  styleUrls: ['./salesperson-mapping.component.scss']
})
export class SalespersonMappingComponent implements OnInit {

  pageTitle: string = SIDE_NAVE_TITLES.salespersonMapping;

  @Output() titleHeading = new EventEmitter<string>();
  @Output() shouldDisplayTitle = new EventEmitter<boolean>();

  tableColumns = TableSchema['sales-mapping'];
  loading = false;
  salesMappingData: any = [];
  selectedRow: any;
  setDialogName: string;
  btnName: string;
  viewAddSalesMapping: boolean;
  headerSelectOptions: any = {}
  currentRow: any;
  onClickDelete: boolean;
  setIndex: any;
  showAlertPopup = false
  message: string;

  constructor(
    private ccassService: CcassService,
    private apiService: ApiService,
    private defaultService: DefaultService,
    private messageService: MessageService,
    private dataService: DataService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.titleHeading.emit(this.pageTitle);
    this.shouldDisplayTitle.emit(false);
    this.getMappingData()
  }

  getMappingData() {
    this.ccassService.ccassfindOne('', 'v1/salesperson-mapping').then(response => {
      if (response['status'] && response['status'] === 'success') {
        if(response['salespersonMapping'] && response['salespersonMapping'] !== null) {
          this.salesMappingData = response['salespersonMapping'];
          this.setHeaderSelectOptions(response['salespersonMapping'])
        } else {
          this.salesMappingData = []
          this.setHeaderSelectOptions([])
        }
      } else {
        this.messageService.add({ severity: 'error', detail: response['status'] });
        this.loading = false;
        // handle failure
      }
    }).catch(err => {
      if (err.status == 500) {
        this.messageService.add({ severity: 'error', detail: err['statusText'] ? err['statusText'] : 'Internal server error' });
      }
      else if (err.status == 502) {
        this.messageService.add({ severity: 'error', detail: err.status ? err.status + 'Bad Gateway' : '502 Bad Gateway' });
      } else {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
      this.loading = false;
      // handle error
    });
  }

  setHeaderSelectOptions(data: any) {
    let nameOptions = [{ label: 'All', value: null }]
    if (data.length > 0) {
      data?.forEach((d: any) => {
        if (d.salespersonName) { nameOptions.push({ label: d.salespersonName, value: d.salespersonName }); }
      })
      const uniqueFilenameOptions = [...new Set(nameOptions.map(item => item.label))];
      nameOptions = []; 
      uniqueFilenameOptions?.forEach((element: any) => nameOptions.push({ label: element, value: element == 'All' ? null : element }));
      this.headerSelectOptions['salespersonName'] = nameOptions;
      this.loading = false
    } else {
      this.headerSelectOptions['salespersonName'] = nameOptions;
      this.loading = false
    }
  }

  onAddMapping() {
    this.selectedRow = undefined;
    this.setDialogName = 'ADD';
    this.btnName = 'SAVE';
    this.viewAddSalesMapping = true;
  }

  editMapping(event: any) {
    this.selectedRow = event['row'];
    this.setDialogName = 'EDIT';
    this.btnName = 'UPDATE';
    this.viewAddSalesMapping = true;
  }

  deleteMapping(event: any) {
    this.currentRow = event.row;
    this.onClickDelete = true;
    this.selectedRow = event.row;
    this.setIndex = event.index;
  }

  shoeerrorpopup(event:any) {
    this.showAlertPopup = true
    this.message = event.message
  }

  onClickYes() {
    const url = 'v1/salesperson-mapping'
    this.ccassService.delete(this.selectedRow['mappingId'], url).then(data => {
      if (data['status'] === 'success') {
        const message = data['message']
        this.shoeerrorpopup({message})
      } else {
        this.messageService.add({ severity: 'error', detail: data['message'] ? data['message'] : data['status'] });
        this.loading = false;
      }
    }).catch(err => {
      this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      this.loading = false;
    })
  }


  onClickok() {
    this.getMappingData()
  }


}
